import { Container, Typography } from '@mui/material';

function Governance() {
  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Typography variant="h1" sx={{ mb: 4, fontFamily: 'Bebas Neue' }}>
        Governance
      </Typography>
      <Typography variant="body1" paragraph>
        Coming soon...
      </Typography>
    </Container>
  );
}

export default Governance;
